import { createContext } from 'react';

// undefined value used in desktop
export default createContext(undefined);
